import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import it from './it.json';
import pl from './pl.json';
import pt from './pt.json';
import ru from './ru.json';
import nl from './nl.json';

export const translations = {
  de,
  en,
  es,
  fr,
  it,
  pl,
  pt,
  ru,
  nl,
};

export type Language = keyof typeof translations;

const isSupportedLanguage = (language?: string): language is Language =>
  !!language && language in translations;

export const getMessages = (language?: string): Record<string, string> => {
  const messages: Record<string, string> = { ...en };
  const selected: Record<string, string> = isSupportedLanguage(language)
    ? translations[language]
    : {};

  Object.keys(selected).forEach((key) => {
    if (selected[key] !== '') {
      messages[key] = selected[key];
    }
  });

  return messages;
};

export { useTranslations, isMissingCopy } from './useTranslations';
export { injectTranslations } from './injectTranslations';
export type { TranslationKey, TranslationsFunc } from './types';
